import { render, staticRenderFns } from "./accountCenter.vue?vue&type=template&id=6e0c1871&scoped=true&"
import script from "./accountCenter.vue?vue&type=script&lang=js&"
export * from "./accountCenter.vue?vue&type=script&lang=js&"
import style0 from "./accountCenter.vue?vue&type=style&index=0&id=6e0c1871&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0c1871",
  null
  
)

export default component.exports